/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import useDebounce from "../../../hooks/useDebounce";

import DatePickerComp from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import "./DatePicker.scss";
interface DatePickerProps {
   dateChanged?: boolean
   nombreId: string
   setDateChanged: (dateChanged: boolean) => void
   setInputValue: any
   type: string
   title: string
   placeholder: any
   ageAlert?: boolean
   listInputAgeAlert?: string[]
   errorMessage?: string
   inputIsError?: boolean
   icon?: any;
   calendarClassName?: string
   tabOrder?: number
   value?: string
   validateBirthDate?: boolean
}

const myCustomLocale = {
   // months list by order
   months: [
       "Enero",
       "Febrero",
       "Marzo",
       "Abril",
       "Mayo",
       "Junio",
       "Julio",
       "Agosto",
       "Septiembre",
       "Octubre",
       "Noviembre",
       "Diciembre",
   ],

   // week days by order
   weekDays: [
       {
           name: "Domingo", // used for accessibility
           short: "S", // displayed at the top of days' rows
           isWeekend: true, // is it a formal weekend or not?
       },
       {
           name: "Lunes",
           short: "M",
       },
       {
           name: "Martes",
           short: "T",
       },
       {
           name: "Miercoles",
           short: "W",
       },
       {
           name: "Jueves",
           short: "T",
       },
       {
           name: "Viernes",
           short: "F",
       },
       {
           name: "Sábado",
           short: "S",
           isWeekend: true,
       },
   ],

   // just play around with this number between 0 and 6
   weekStartingIndex: 0,

   // return a { year: number, month: number, day: number } object
   getToday(gregorainTodayObject) {
       return gregorainTodayObject;
   },

   // return a native JavaScript date here
   toNativeDate(date) {
       return new Date(date.year, date.month - 1, date.day);
   },

   // return a number for date's month length
   getMonthLength(date) {
       return new Date(date.year, date.month, 0).getDate();
   },

   // return a transformed digit to your locale
   transformDigit(digit) {
       return digit;
   },

   // texts in the date picker
   nextMonth: "Siguiente Mes",
   previousMonth: "Anterior mes",
   openMonthSelector: "Abrir selección de mes",
   openYearSelector: "Abrir selección de año",
   closeMonthSelector: "Cerrar selección de mes",
   closeYearSelector: "Cerrar selección de año",
   defaultPlaceholder: "Seleccionar...",

   // for input range value
   from: "desde",
   to: "hasta",

   // used for input value when multi dates are selected
   digitSeparator: ",",

   // if your provide -2 for example, year will be 2 digited
   yearLetterSkip: 0,

   // is your language rtl or ltr?
   isRtl: false,
};


function getMinimumDateForAge(age: number): { year: number; month: number; day: number } {
   const today = new Date();
   const minimumDate = new Date(today.getFullYear() - age, today.getMonth(), today.getDate());
   
   return {
     year: minimumDate.getFullYear(),
     month: minimumDate.getMonth() + 1, // Los meses en JS son base 0
     day: minimumDate.getDate(),
   };
 }

const birthDateFields = ['birth_date', 'birthdate']

const DatePicker = ({
   setDateChanged,
   setInputValue,
   nombreId,
   type,
   title,
   placeholder,
   ageAlert = false,
   listInputAgeAlert = [],
   errorMessage,
   inputIsError = false,
   icon,
   calendarClassName = "custom-datepicker-calendar-aceleradora",
   tabOrder,
   value,
   validateBirthDate
}: DatePickerProps ) => {
    const date = new Date();
    const currentYear = date.getFullYear();

   //  const genericRef = useRef<HTMLElement>(null);

    const maximumDate = {
        year: currentYear,
        month: date.getMonth() + 1,
        day: date.getDate(),
    };
    const [inputDate, setInputDate] = useState(() => {
      if(!value) return ""

      const [day, month, year] = value.split("-");

      if(!day || !month || !year) return ""

      return `${day}/${month}/${year}`

    }); // Para manejar la entrada desde el teclado

    const debouncedInputDate = useDebounce(inputDate, 500);

    const [isFocused, setIsFocused] = useState(false);


    const [selectedDay, setSelectedDay] = useState<{
        day: number;
        month: number;
        year: number;
    } | null>(null);

    const dateIsValid = (date: string) => {
      const dateValues = date.split('/').map(Number);

      if(dateValues.length !== 3) return false

      const dateValuesAreValid = dateValues.every((value) => !isNaN(value));

      if (!dateValuesAreValid)  return false

      const [day, month, year] = dateValues;

      const isValidDay = day >= 1 && day <= 31;

      const isValidMonth = month >= 1 && month <= 12;

      const isValidYear = year >= 1900 && year <= currentYear;

      if (!isValidDay || !isValidMonth || !isValidYear) {
          return false
      }

      return true

    }

    useEffect(() => {
      const datValuesIsValid = dateIsValid(debouncedInputDate)
      if (!datValuesIsValid) return
      const dateValues = debouncedInputDate.split('/').map(Number);
      const [day, month, year] = dateValues;
      const parsedDate = { day, month, year };
      setSelectedDay(parsedDate);
      setDateChanged(true);
      setInputValue(nombreId, `${day}-${month}-${year}`, type);
    }, [debouncedInputDate]);

    useEffect(() => {
         if(!value && inputDate?.length > 0) {
            setInputDate('')
         }
    }, [value])

   const inputIsForBirthDate = birthDateFields.includes(nombreId);

    const handleDateChange = (choosenDate) => {
        setSelectedDay(choosenDate);
        setInputDate(
            `${choosenDate.day}/${choosenDate.month}/${choosenDate.year}`
        );
        setDateChanged(true);
        setInputValue(
            nombreId,
            `${choosenDate.day}-${choosenDate.month}-${choosenDate.year}`,
            type
        );
    };

   //  const handleInputBlur = () => {
   //      const [day, month, year] = inputDate.split("/").map(Number);
   //      if (!inputDate.trim()) {
   //          setInputIsError(true);
   //      }
   //      if (day && month && year) {
   //          const parsedDate = { day, month, year };
   //          setSelectedDay(parsedDate);
   //          setDateChanged(true);
   //          setInputValue(nombreId, `${day}-${month}-${year}`, type);
   //          setInputIsError(false);
   //      }
   //  };

    const handleDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value.replace(/\D/g, ""); // Elimina caracteres no numéricos

        // Limita el formato a DD/MM/AAAA
        let formattedInput = "";
        if (input.length > 2) {
            let day = input.slice(0, 2);
            day = parseInt(day) > 31 ? "31" : day; // Limita el día máximo a 31
            formattedInput = day + "/";
        } else {
            formattedInput = input;
        }
        if (input.length > 4) {
            let month = input.slice(2, 4);
            month = parseInt(month) > 12 ? "12" : month; // Limita el mes máximo a 12
            formattedInput += month + "/";
        } else if (input.length > 2) {
            formattedInput += input.slice(2);
        }
        if (input.length > 8) {
            let year = input.slice(4, 8);
            year = parseInt(year) > currentYear ? currentYear.toString() : year;
            year = parseInt(year) < 1900 ? "1900" : year; // Limita el año al rango 1900-currentYear
            formattedInput += year;
        } else if (input.length > 4) {
            formattedInput += input.slice(4);
        }

        setInputDate(formattedInput); // Actualiza el valor del input
    };

    const handleInputDateOnBlur = () => {
         setIsFocused(false);

         const isValidDate = dateIsValid(inputDate);

         if (!isValidDate) {
             setInputDate("");
             setInputValue(nombreId, "", type);
             setSelectedDay(null);
         }
    }

    return (
        <>
            <label id={"title-" + nombreId} className={"a-input__form__title a-input-aceleradora__form__title"}>
                {title}
            </label>
            {placeholder && (
                <span className="a-input__form__texto-ayuda">
                    {placeholder}
                </span>
            )}
            <DatePickerComp
                inputClassName="input-date-picker a-input-date-picker"
                calendarClassName={calendarClassName}
                locale={myCustomLocale}
                value={selectedDay}
                inputPlaceholder={"DD/MM/AAAA"}
                onChange={handleDateChange}
                colorPrimary={"#ee2b7b"}
                maximumDate ={(inputIsForBirthDate && validateBirthDate) ? getMinimumDateForAge(16) : maximumDate}
                renderInput={({ ref }) => (
                    <div className="input-wrapper a-custom-date-picker__input-wrapper">
                        <input
                            ref={ref as React.RefObject<HTMLInputElement>}
                            className="input-date-picker a-input-aceleradora__form__field wtf"
                            value={inputDate}
                            onChange={handleDateInput}
                            onBlur={handleInputDateOnBlur}
                            onFocus={() => setIsFocused(true)}
                            placeholder={placeholder}
                        />
                        {!inputDate && !isFocused && (
                            <img
                                className="calendar-placeholder a-custom-date-picker__calendar-placeholder"
                                src="https://images.ctfassets.net/203frbsx1z3n/2fdROCh05kuVtBzsmgCzPp/55c6486edd19b59d646231c9a54cf4e2/calendario.svg"
                                alt="Calendario"
                            />
                        )}
                    </div>
                )}
            />
            {/* toast para el campo de fecha de nacimiento */}
            {ageAlert && listInputAgeAlert.includes(nombreId) && (
                <div className="o-form-ruta-ideal__form__fcontainer__advertiser">
                    <img src={icon.file.url} alt="icono-información" />
                    <p>{errorMessage}</p>
                </div>
            )}
            {inputIsError && (
                <span className="a-input__form__error-message">
                    * Pregunta obligatoria
                </span>
            )}
        </>
    );
};

export default DatePicker;
